<section class="sh-dialog__content">
  @if (data.shareUrl) {
    <section>
      <h4 class="sh-page-title--small-subsection">{{ "sharing-dialog.share-with-other-users" | translate }}</h4>
      <p>
        <code class="sh-wrap-text">{{ url }}</code>
      </p>
    </section>
  }
</section>
<footer class="sh-dialog__footer">
  <div class="sh-action-group -sh-align-end">
    <ng-container *ngTemplateOutlet="data.shareUrl ? copyButton : okButton"></ng-container>
    <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ data.cancel }}</button>
  </div>
</footer>

<ng-template #copyButton>
  <sh-copy-button [data]="url" [label]="data.ok" (copySuccess)="copySuccess($event)" (copyFailure)="copyFailure($event)"> </sh-copy-button>
</ng-template>

<ng-template #okButton>
  <button type="button" class="sh-button sh-action-group__item" (click)="cancel()">{{ data.ok }}</button>
</ng-template>
